<label>
  <input [id]="name" type="text" [ngModel]="date | datetime: format" readOnly [attr.disabled]="disabled || null" (click)="onClick()" />
  <span (click)="onClear()" title="{{'Clear' | translate}}" *ngIf="clear">X</span>
</label>
